module.exports = __webpack_public_path__ + "static/media/logo.06566f40.svg";